<script lang="ts">
	import Select from 'svelte-select';
	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
	export let options = [];
	export let id: number;

	let optionsWithGenInterests = [];
	let optionsForSelect = [];
	let selectedValue = { value: '', label: '' } as {
		value: string | [string, boolean];
		label: string;
	};

	//parses interest info from picker and sends it to parent component
	$: {
		console.log('new selected interest ', selectedValue.value[0], selectedValue.value[1]);
		let interestName = selectedValue.value[0];
		let isGenInterest = selectedValue.value[1];
		dispatch('message', { value: interestName, selectId: id, isGeneralInterest: isGenInterest });
	}

	$: {
		console.log('options length', options.length);
		createOptionsListWithGeneralInterestsAndInterests();
		optionsForSelect = optionsWithGenInterests.map((interestOption) => {
			return {
				value: [interestOption.name, interestOption.isGeneralInterest],
				label: interestOption.name
			};
		});
	}

	function createOptionsListWithGeneralInterestsAndInterests() {
		optionsWithGenInterests = [];

		let otherOptions = options.filter((option) => option.generalInterest !== null);
		otherOptions.forEach((innerOption) => {
			optionsWithGenInterests.push({ name: innerOption.name, isGeneralInterest: false });
		});
	}
</script>

<div class="container">
	<div class="themed">
		<Select
			{selectedValue}
			items={optionsForSelect}
			on:select={(e) => {
				selectedValue = e.detail;
			}}
			on:clear={() => {
				selectedValue = { label: '', value: ['', false] };
			}}
		/>
	</div>
</div>

<style>
	.themed {
		--background: #f5f5f5;
		--border: 1px solid rgba(0, 0, 0, 0.87);
		--multiItemBG: #66548f;
		--multiItemActiveBG: #776c8e;
		--multiItemActiveColor: white;
		--multiClearBG: white;
		--multiClearFill: #66548f;
		--itemColor: black;
		width: 270px;
	}

	.container {
		display: flex;
		flex-flow: wrap;
		padding: 0;
		margin-left: 140px;
		margin-right: 140px;
	}
</style>
